import FixedModal from "components/fixed-modal";
import React from "react";

type TierOneDebitCardProps = {
  isOpen: boolean;
  toggle: () => void;
};

function TierOneDebitCard({ isOpen, toggle }: TierOneDebitCardProps) {
  return (
    <FixedModal
      isOpen={isOpen}
      toggle={toggle}
      title={"Tier 2 Required"}
      icon="exclamation-solid"
      iconColor="#FEE2E2"
    >
      <div className="modal-card">
        <p>
          To access debit cards please reach out to customer support to upgrade
          to tier 2.
        </p>
      </div>
    </FixedModal>
  );
}

export default TierOneDebitCard;
